import { Link } from 'react-router-dom';
import {
  CargasPage,
  CargasSection,
  CargasViewport,
  cargasButtonClassName,
} from './components/CargasLayout.jsx';

const closedDecisions = [
  'La transcripcion de sucursal se canoniza como guia derivada, no como clon ciego.',
  'La relacion minima queda en guias.guia_origen_id + guias.sucursal_origen_transcripcion_id + guias.tipo_origen.',
  "El valor esperado de tipo_origen para este flujo es 'TRANSCRIPCION_SUCURSAL'.",
];

export default function TranscripcionGuiaDeSucursal() {
  return (
    <CargasPage
      title="Transcripcion Guia de Sucursal"
      description="Flujo canonico definido. La emision operativa todavia no esta habilitada desde esta pantalla."
      breadcrumbs={[
        { label: 'Cargas', href: '/cargas/dashboard' },
        { label: 'Operativas' },
        { label: 'Transcripcion Guia de Sucursal' },
      ]}
      actions={<Link to="/cargas/dashboard" className={cargasButtonClassName}>Volver</Link>}
    >
      <CargasViewport className="gap-4 px-4 py-4">
        <CargasSection
          title="Estado actual"
          description="Se cerró la decisión de modelo, pero falta exponer un backend dedicado para crear la guía derivada con validaciones operativas."
        >
          <div className="rounded-xl border border-[rgba(var(--warning),0.3)] bg-[rgba(var(--warning),0.12)] px-4 py-3 text-sm text-[rgb(var(--fg))]">
            Accion bloqueada: esta pantalla no permite transcribir hasta que exista un endpoint que persista la guia derivada con vinculo canonico al origen.
          </div>
        </CargasSection>

        <CargasSection
          title="Decision cerrada"
          description="Modelo minimo adoptado para no seguir infiriendo transcripciones por copia de datos."
        >
          <ul className="space-y-2 text-sm text-[rgba(var(--fg),0.76)]">
            {closedDecisions.map((item) => <li key={item} className="rounded-xl border border-[rgba(var(--border),0.45)] bg-[rgba(var(--subpanel),0.45)] px-3 py-2">{item}</li>)}
          </ul>
        </CargasSection>
      </CargasViewport>
    </CargasPage>
  );
}
